module.exports = __webpack_public_path__ + "static/media/minus.7ffe989a.svg";